// ─────────────────────────────────────────────────────────────────────
// A BOOKING DELETE, THEN WHAT HANGS OFF IT — ONLY IF IT WENT (#284).
//
// The shell deletes a booking and then, best-effort, the planned matches linked
// to it (the booking slice stays unaware of planned matches). It used to run
// that cleanup UNCONDITIONALLY — harmless while every delete succeeded, wrong
// once the server started refusing some: a paid booking is not deleted
// (`booking_has_payment`, #526), so the booking stands and the cleanup removed
// its plan anyway, through `DELETE /planned-matches`. The server deletes the
// plans of a booking it deletes in the same transaction, so on success there
// is nothing to lose by asking again, and on failure there is a plan to keep.
// ─────────────────────────────────────────────────────────────────────

/** Run `remove`; run `cascade` only when it succeeded. The cascade never fails the delete. */
export async function deleteThenCascade<R extends { success: boolean }>(
  remove: () => Promise<R>,
  cascade: () => Promise<unknown>,
): Promise<R> {
  const r = await remove();
  if (!r.success) return r;
  try {
    await cascade();
  } catch {
    /* ignore — the booking is already gone */
  }
  return r;
}
